
// @ts-nocheck


export const localeCodes =  [
  "it",
  "en"
]

export const localeLoaders = {
  "it": [],
  "en": []
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": true
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config",
  "locales": [
    {
      "code": "it",
      "site": "it",
      "name": "Italiano",
      "language": "it-IT"
    },
    {
      "code": "en",
      "site": "en",
      "name": "English",
      "language": "en-US"
    }
  ],
  "defaultLocale": "it",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "https://www.suntimes.it",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {
    "index": {
      "it": "/",
      "en": "/"
    },
    "be-suntimers/index": {
      "it": "/be-suntimers",
      "en": "/be-suntimers"
    },
    "fight-gravity/index": {
      "it": "/fight-gravity",
      "en": "/fight-gravity"
    },
    "wonder-academy/index": {
      "it": "/wonder-academy",
      "en": "/wonder-academy"
    },
    "fight-gravity-event/index": {
      "it": "/fight-gravity-event",
      "en": "/fight-gravity-event"
    },
    "podcast-grandi-imprese/index": {
      "it": "/podcast-grandi-imprese",
      "en": "/podcast-grandi-imprese"
    },
    "get-in-touch/index": {
      "it": "/contatti",
      "en": "/get-in-touch"
    },
    "projects/[slug]/index": {
      "it": "/progetti/[slug]",
      "en": "/projects/[slug]"
    },
    "what/index": {
      "it": "/what",
      "en": "/what"
    },
    "who/index": {
      "it": "/who",
      "en": "/who"
    },
    "why/index": {
      "it": "/why",
      "en": "/why"
    },
    "blog/index": {
      "it": "/blog",
      "en": "/blog"
    },
    "blog/[slug]/index": {
      "it": "/blog/[slug]",
      "en": "/blog/[slug]"
    },
    "chat-lgbt/index": {
      "it": "/chat-lgbt",
      "en": "/chat-lgbt"
    },
    "cookie-policy/index": {
      "it": "/cookie-policy",
      "en": "/cookie-policy"
    },
    "privacy-policy/index": {
      "it": "/privacy-policy",
      "en": "/privacy-policy"
    },
    "iso-certified/index": {
      "it": "/iso-certified",
      "en": "/iso-certified"
    },
    "whistleblowing/index": {
      "it": "/whistleblowing",
      "en": "/whistleblowing"
    },
    "form-submission-success": {
      "it": "/richiesta-inviata",
      "en": "/request-sent"
    },
    "form-submission-failure": {
      "it": "/richiesta-non-inviata",
      "en": "/request-not-sent"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "it",
    "site": "it",
    "name": "Italiano",
    "language": "it-IT",
    "files": []
  },
  {
    "code": "en",
    "site": "en",
    "name": "English",
    "language": "en-US",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
